import React from "react";
import { Flex } from "@chakra-ui/react";
import ReactDOM from "react-dom/client";
import GlobalThemeProvider from "src/styling/GlobalThemeProvider";
import { Provider as ReduxProvider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { HashRouter } from "react-router-dom";

import ToRender from "./RecreateFlow";

const remote = window.require("@electron/remote");

export default function renderStory({ store, persistor }) {
  if (remote.getCurrentWindow) {
    const browserWindow = remote.getCurrentWindow();
    browserWindow.setResizable(true);
  }

  ReactDOM.createRoot(document.getElementById("root")).render(
    <ReduxProvider store={store}>
      <PersistGate
        loading={<div>Retrieving persisted data.</div>}
        persistor={persistor}
      >
        <HashRouter>
          <GlobalThemeProvider>
            <React.Fragment>
              <Center withCenter={true}>
                <ToRender />
              </Center>
            </React.Fragment>
          </GlobalThemeProvider>
        </HashRouter>
      </PersistGate>
    </ReduxProvider>
  );
}

const Center = ({ withCenter, children }) => {
  if (!withCenter) {
    return children;
  }
  return (
    <Flex
      // bg="pink"
      justifyContent="center"
      alignItems="center"
      width="100vw"
      minHeight="100vh"
    >
      <Flex position="relative">{children}</Flex>
    </Flex>
  );
};
